import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { getProductInventoryMaximium } from "../../services/dashboards";

export default function DashboardMaxExistenciasChart({ inventarioSelected }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!inventarioSelected) return;
    const fetchData = async () => {
      try {
        const result = await getProductInventoryMaximium({ inventario: inventarioSelected });
        setData(result.top_mas_existencias);
      } catch (err) {
        console.error("Error cargando máximos:", err);
      }
    };
    fetchData();
  }, [inventarioSelected]);

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full lg:w-1/2">
      <h3 className="text-lg font-semibold mb-2 text-gray-700">Productos con más existencias</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} layout="vertical" margin={{ left: 50 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="nombre" type="category" width={140} />
          <Tooltip />
          <Bar dataKey="cantidad" fill="#4f46e5" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}